module.exports = __webpack_public_path__ + "img/print@2x.0b6b538.webp";